import { FieldProductDetail } from "@/components/field/FieldProductDetail";

const HiveScale = () => <FieldProductDetail productId="Scale4G" />;
export const HiveScale2G = () => <FieldProductDetail productId="Scale" />;

export default HiveScale;
